var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { ThemeProvider } from 'emotion-theming';
import Header from 'components/Header/Header';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AsyncComponent from 'components/AsyncComponent';
import constants from 'app/constants/global-constants';
import theme from '../../assets/styles/theme';
import MaintenanceMode from './MaintenanceMode';
var ProtectedRouteContainer = AsyncComponent(function () {
    return import('./ProtectedRouteContainer');
});
var toastOptions = {
    hideProgressBar: true,
    closeButton: false,
};
var App = function () {
    if (constants.IS_MAINTENANCE_ENABLED)
        return React.createElement(MaintenanceMode, null);
    return (React.createElement(ErrorBoundary, null,
        React.createElement("div", { className: "app-wrapper" },
            React.createElement(Helmet, { titleTemplate: "%s - Neo4j Sandbox", defaultTitle: "Home - Neo4j Sandbox" },
                React.createElement("meta", { name: "description", content: "Neo4j Sandbox" })),
            React.createElement(ThemeProvider, { theme: theme },
                React.createElement(Header, null),
                React.createElement(ToastContainer, __assign({ position: "top-right" }, toastOptions)),
                React.createElement(ErrorBoundary, null,
                    React.createElement(Switch, null,
                        React.createElement(Route, { exact: true, path: "*", component: ProtectedRouteContainer }),
                        React.createElement(Route, { exact: true, path: "/login" },
                            React.createElement(ProtectedRouteContainer, null))))))));
};
var mapStateToProps = function (state) { return ({ user: state.user }); };
export default connect(mapStateToProps)(App);
